import { MapContainer, TileLayer } from 'react-leaflet';
import L from 'leaflet';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

import 'leaflet/dist/leaflet.css';

// Fix dell'icon default: bundler-friendly (Vite/Rolldown gestisce gli URL
// degli asset). Senza questo, le marker si vedono spezzate (problema noto
// di Leaflet con i bundler ESM).
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const OSM_TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const OSM_ATTRIBUTION =
  '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

/**
 * MapView — wrapper di `react-leaflet/MapContainer` con tile OSM standard.
 *
 * Pre-applicate:
 * - tile layer OpenStreetMap (preset standard del progetto),
 * - fix dell'icon default Leaflet (asset via bundler),
 * - import del CSS Leaflet (sparso nei consumer legacy, ora centralizzato).
 *
 * Tutte le altre props (`center`, `zoom`, `style`, `whenReady`, …) sono
 * passate attraverso. I figli (Marker, Popup, Polyline, ecc.) vanno
 * importati direttamente da `react-leaflet` quando servono nel consumer.
 */
export default function MapView({
  center = [45.4642, 9.19], // Milano default
  zoom = 12,
  style = { height: '100%', width: '100%' },
  scrollWheelZoom = true,
  tileUrl = OSM_TILE_URL,
  tileAttribution = OSM_ATTRIBUTION,
  children,
  ...rest
}) {
  return (
    <MapContainer
      center={center}
      zoom={zoom}
      style={style}
      scrollWheelZoom={scrollWheelZoom}
      {...rest}
    >
      <TileLayer url={tileUrl} attribution={tileAttribution} />
      {children}
    </MapContainer>
  );
}

// Ri-export delle primitive più usate, per tenere i consumer fuori da
// `react-leaflet` diretto.
export {
  MapContainer,
  TileLayer,
  GeoJSON,
  Marker,
  Popup,
  Polyline,
  Tooltip,
  useMap,
} from 'react-leaflet';

// Ri-export del namespace `L` per consumer Leaflet imperativi
// (`L.map()`, `L.marker()`, `L.tileLayer()`, …). Importandolo da qui i
// consumer ereditano l'icon-fix applicato in cima al modulo, senza
// duplicare il boilerplate `delete L.Icon.Default.prototype._getIconUrl`.
export { L };
